export default "__VITE_PUBLIC_ASSET__1adc3b2c__"